import { useQuery } from 'react-query';

import { getCardAssignees as queryFn } from 'api/endPoints/getCardAssignees';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCardAssignees = (params: QueryParams) => {
    return useQuery<ICardAssignees[], QueryError, ICardAssignees[], [QueryKeys, unknown]>({
        queryKey: ['getCardAssignees', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface ICardAssignees {
    firstName: string;
    id: number;
    imageName: string;
    lastName: string;
    userName: string;
}
